import { fromLocalStorage } from "./local-storage";
const location = window.location

export function getUserId() {
    return fromLocalStorage<any>('@zustand/useUserStore', true).state?.jwt?.user || '';
}

export const getUserIdByPathname = () => Number(location.pathname.split('/')[2])
export const getUserNameByPathname = () => location.pathname.split('/')[3]

export const navigateToUser = (id, path = '') => {
    return `/user/${id}` + path
}

export const getFormattedUserName = () => {
    return decodeURIComponent(location.pathname.split('/')[3])
}